import React from 'react'

import { ReactComponent as HomeIcon } from '../../../../assets/icons/home-alt.svg'
import { ReactComponent as PawIcon } from '../../../../assets/icons/paw-vet.svg'
import { ReactComponent as BellIcon } from '../../../../assets/icons/bell.svg'
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/calendar-alt.svg'
import { ReactComponent as SolicitationsIcon } from '../../../../assets/icons/comments-alt.svg'
import { ReactComponent as DashboardIcon } from '../../../../assets/icons/chart-simple.svg'

export const MENU_OPTIONS = [
  {
    ref: 'home',
    icon: <HomeIcon />,
    title: 'Início',
    url: 'vets/'
  },
  {
    ref: 'tutorsAndPets',
    icon: <PawIcon />,
    title: 'Tutores e Pets',
    url: 'vets/tutores-e-pets'
  },
  {
    ref: 'calendar',
    icon: <CalendarIcon />,
    title: 'Calendário',
    url: 'vets/calendar/daily'
  },
  {
    ref: 'solicitations',
    icon: <SolicitationsIcon />,
    title: 'Solicitações',
    url: 'vets/solicitations'
  },
  {
    ref: 'dashboard',
    icon: <DashboardIcon />,
    title: 'Meu painel',
    url: 'vets/dashboard',
    freelanceDisallowed: true
  },
  {
    ref: 'notifications',
    icon: <BellIcon />,
    title: 'Avisos',
    url: 'vets/notifications'
  }
]

// Define a aba ativa para cada rota
export const vetRoutesPath = {
  home: [
    '/vets/'
  ],
  tutorsAndPets: [
    '/vets/tutores-e-pets'
  ],
  calendar: [
    '/vets/calendar/daily',
    '/vets/calendar/monthly'
  ],
  notifications: [
    '/vets/notifications',
    '/vets/notifications/notification-details/:id'
  ],
  solicitations: [
    '/vets/solicitations',
    '/vets/solicitations/new-agenda-block',
    '/vets/solicitations/new-scheduling',
    '/vets/solicitations/solicitations-history'

  ],
  dashboard: [
    '/vets/dashboard'
  ]
}
